import React from 'react';
import {useI18nContext} from "../../../../contexts/I18nContext";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import {Observer} from "mobx-react-lite";
import Button from "../../../../ui_components/Button/Button";
import Box from "../../../../ui_components/Box/Box";
import Width from "../../../../ui_components/common/enums/Width";
import Alignment from "../../../../ui_components/common/enums/Alignment";
import ShowPagination from "../../../../ui_components/ShowPagination/ShowPagination";
import MessageCard from "../../../../ui_components/MessageCard/MessageCard";
import DateTimeRangeSelect from "../../../../ui_components/DateTimeRageSelect/DateTimeRangeSelect";
import ShowDate from "../../../Info/ShowDate/ShowDate";
import clsx from "clsx";
import TransactionStatus from "../../../../entities/TransactionStatus";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import ShowGeneralComment from '../../../Info/ShowGeneralComment/ShowGeneralComment';
import ShopProductTransactionsProperties from './ShopProductTransactionsProperties';
import { useStyles } from './ShopProductTransactions.style';
import ShowArticleAmount from '../../../Info/ShowArticleAmount/ShowArticleAmount';

const ShopProductTransactions: React.FC<ShopProductTransactionsProperties> = ({
                                                                                store
                                                                            }) => {
    const classes = useStyles();

    const i18n = useI18nContext();

    const onPaginationChange = async (page: number, pageSize: number) => {
        await store.goToPage(page, pageSize);
    }

    return <Observer>
        {() => (
            <>
            
                <div className={classes.contacts_container}>
                    <div className={classes.body}>
                        <Box className={classes.filter_container} width={Width.FULL_WIDTH}
                                justifyContent={Alignment.SPACE_BETWEEN}>
                            <DateTimeRangeSelect
                                selectedFrom={store.from}
                                selectedTo={store.to}
                                label={i18n.translate("DATE_RANGE")}
                                onChange={(from, to) => {
                                    store.from = from;
                                    store.to = to;
                                }}/>
                            <div className={classes.btn_container}>
                                <Button
                                    onClick={() => {
                                        store.search()
                                    }}
                                    className={classes.search_btn}
                                    text={i18n.translate("SEARCH")}
                                />
                                <Button
                                    onClick={() => {
                                        store.cleanFilter()
                                    }}
                                    className={classes.search_btn}
                                    startIcon={<FilterAltOffIcon/>}
                                    tooltip={i18n.translate("CLEAN_FILTER")}
                                />
                            </div>
                        </Box>
                        {!store.isEmpty &&
                        <div className={classes.contacts_table}>
                            <ShowPagination onChange={onPaginationChange}
                                            elementLabel={i18n.translate("TRANSACTIONS")}
                                            pagination={store.pagination}/>
                            <div className={classes.elements_container}>
                                {store.shopProductStockTransactions.map((transaction, i) => (
                                    <div key={i} className={clsx(
                                        classes.contact_info_container,
                                        transaction.status === TransactionStatus.FAILURE && classes.error_container
                                    )}>
                                        <ShowDate timestamp={transaction.createdAt}/>
                                        <ShowArticleAmount
                                            value={transaction.amount}
                                                articleName={transaction.shopProductName}
                                            valueBefore={transaction.amountBefore}
                                        />
                                        <ShowGeneralComment value={transaction.comment}/>
                                    </div>
                                ))}
                            </div>
                            <ShowPagination
                                onChange={onPaginationChange}
                                elementLabel={i18n.translate("TRANSACTIONS")}
                                pagination={store.pagination}/>
                        </div>
                        }
                        {store.isEmpty &&
                        <MessageCard icon={AccountBalanceIcon} title={i18n.translate("NO_TRANSACTIONS_TITLE")}
                                        subtitle={i18n.translate("NO_TRANSACTIONS_SUBTITLE")}/>}
                    </div>
                </div>
            </>
        )}
    </Observer>
}

export default ShopProductTransactions;
